// extracted by mini-css-extract-plugin
export default {"noOptionsMessage":"noOptionsMessage-vFQZb"};